import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import axios from 'axios';
import { getToken, getDecryptJwtToken } from '../../helpers/utility';
import { SERVER_ADDRESS } from '../../settings';
import authAction from '../../redux/auth/actions';
import IntlMessages from '../../components/utility/intlMessages';
import Popover from '../../components/uielements/popover';
import TopbarDropdownWrapper from './topbarDropdown.style';
import userpic from '../../image/user1.png';


const { logout } = authAction;
var TOKEN = "";

class TopbarUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			userJwtInfos: {},
		};
		this.handleVisibleChange = this.handleVisibleChange.bind(this);
		this.hide = this.hide.bind(this);
	}

	hide() {
		this.setState({ visible: false });
	}

	handleVisibleChange() {
		this.setState({ visible: !this.state.visible });
	}

	render() {
		const content = (
			<TopbarDropdownWrapper className="isoUserDropdown">
				<Link to="/dashboard/Utilizadores" className="isoDropdownLink">
					<IntlMessages id="themeSwitcher.settings" />
				</Link>
				<a className="isoDropdownLink" onClick={this.logout} href="# ">
					<IntlMessages id="topbar.logout" />
				</a>
			</TopbarDropdownWrapper>
		);

		let src = userpic;
		if (this.state.b64 != null) {
			src = this.state.b64;
		}

		return (
			<Popover
				content={content}
				trigger="click"
				visible={this.state.visible}
				onVisibleChange={this.handleVisibleChange}
				arrowPointAtCenter={true}
				placement="bottomLeft"
			>
				<div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
					<span style={{color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bold', fontSize: '.8rem'}}>{this.state?.userJwtInfos?.name}</span>
					<div className="isoImgWrapper">
						<img alt="user" src={src} />
					</div>
				</div>
			</Popover>
		);
	}

   componentDidMount() {
      TOKEN = getToken();
	  this.setState({userJwtInfos: getDecryptJwtToken(TOKEN)})
      this.fetch();
   }

   logout = () => {
	localStorage.removeItem('googleTreeFolder');
	this.props.logout();
   }

   fetch = () => {
      axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetUserPhoto`,
      {
         headers: {
            Authorization: `Bearer ${TOKEN}`
         },
      }
   )
      .then(data => {
         const b64 = `data:image/png;base64,${data.data}`;
         if (data.data)
            this.setState({ b64: b64 });
      })
   }
}

export default connect(
	null,
	{ logout }
)(TopbarUser);
